import { AlertCircle } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  className?: string;
}

export function ErrorState({ title = "Error", message, onRetry, className }: ErrorStateProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center py-12 text-center", className)}>
      <AlertCircle className="text-red-400 w-12 h-12" />
      <h3 className="text-lg font-medium text-gray-900 mt-4">{title}</h3>
      <p className="text-sm text-red-500 mt-1">{message}</p>
      {onRetry && <Button className="mt-4" onClick={onRetry}>Reintentar</Button>}
    </div>
  );
}
